<script setup lang="ts">
import { computed } from 'vue'

import IconDesign from '@/components/atoms/icons/IconDesign.vue'
import BetaAppearanceIcon from '@/components/beta-dashboard/atoms/BetaAppearanceIcon.vue'
import BetaNavigationDisclosure from '@/components/beta-dashboard/molecules/BetaNavigationDisclosure.vue'

const props = defineProps<{
    active?: boolean
    openingDesign?: boolean
}>()

const emit = defineEmits<{
    design: []
    layout: []
}>()

const items = computed(() => [
    {
        id: 'design',
        label: props.openingDesign ? 'Abrindo Design…' : 'Design',
        leadingIcon: IconDesign,
        disabled: props.openingDesign,
        busy: props.openingDesign,
    },
    {
        id: 'layout',
        label: 'Layout',
        leadingIcon: BetaAppearanceIcon,
        current: props.active,
    },
])

const selectItem = (id: string) => {
    if (id === 'design') emit('design')
    if (id === 'layout') emit('layout')
}
</script>

<template>
    <BetaNavigationDisclosure
        label="Aparência"
        :icon="IconDesign"
        :items="items"
        :active="props.active"
        @select="selectItem"
    />
</template>
